module.exports = __webpack_public_path__ + "img/folios-icon-dark.dc113755.svg";